module.exports = __webpack_public_path__ + "img/bulb.714d5198.png";